function a(t) {
  var n = String(t).match(/^function (\w*)/);
  return n == null ? "" : n[1];
}
export {
  a as default
};
